module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "teams-creation@2x.7bcc2d9e.png" + "?" + Date.now();